// import { useFlag } from 'hooks/use-flag';
import ReadyToInterview from '../../../assets/img/available_for_work_new.svg';
import UnAvailableForJobs from '../../../assets/img/not_available_for_work_new.svg';
import OpenToOffers from '../../../assets/img/openToOffersNew.svg';

export const ActionType = {
  GET_AVAILABILITY_STATUSES: 'GET_AVAILABILITY_STATUSES',
};

// TODO: remove this
export const DEVELOPER_AVAILABILITY_STATUSES = {
  RESUME_MATCHABILITY_ISSUES: 'Resume Matchability Issues',
  NOT_AVAILABLE: 'Not Available',
  PART_TIME: 'Part Time',
  FULL_TIME: 'Full Time',
  A_V_MATCHABILITY_ISSUES: 'A/V Matchability Issues',
  PRE_FULLTIME: 'Pre-Fulltime',
  VISA_LEGAL_ISSUES: 'Visa/Legal Issues',
  NEED_QUICK_REMATCH: 'Need quick rematch',
  ADVANCED_NOTICE_TOO_LONG: 'Advanced Notice Too Long',
};

export const DEVELOPER_AVAILABILITY_TYPES = {
  FULL_TIME: {
    key: 'fulltime',
    label: 'Full Time',
  },
  PART_TIME: {
    key: 'parttime',
    label: 'Part Time',
  },
  PRE_FULL_TIME: {
    key: 'pre-fulltime',
    label: 'Pre Full Time',
  },
};

export const DEVELOPER_AVAILABILITY_TYPES_NEW = {
  FULL_TIME: {
    key: 'FULL TIME',
    label: 'Full Time',
  },
  PART_TIME: {
    key: 'PART TIME',
    label: 'Part Time',
  },
  PRE_FULL_TIME: {
    key: 'PRE-FULLTIME',
    label: 'Pre Full Time',
  },
  
};

export const getAvailabilityTypeOptions = () => {
  return Object.keys(DEVELOPER_AVAILABILITY_TYPES).map((key) => ({
    label: DEVELOPER_AVAILABILITY_TYPES[key].label,
    key: DEVELOPER_AVAILABILITY_TYPES[key].key,
  }));
};

export const AVAILABILITY_ANSWERS_KEYS = {
  READY_TO_INTERVIEW: 'ready-to-interview',
  OPEN_TO_OFFERS: 'open-to-offers',
  UNAVILABILE_FOR_JOBS: 'not-looking-for-job',
  UNKNOWN: 'unknown',
};

export const AVAILABILITY_ANSWERS = {
  READY_TO_INTERVIEW: {
    key: 'ready-to-interview',
    label: 'Ready to Interview',
    icon: ReadyToInterview,
    color: 'green'
  },
  OPEN_TO_OFFERS: {
    key: 'open-to-offers',
    label: 'Open to Offers',
    icon: OpenToOffers,
    color: 'green'
  },
  UNAVILABILE_FOR_JOBS: {
    key: 'not-looking-for-job',
    label: 'Unavailable for jobs',
    icon: UnAvailableForJobs,
    color: 'red'
  },
  UNKNOWN: {
    key: 'unknown',
    label: 'Unknown',
    color: 'red'
  },
};

export const AVAILABILITY_ANSWERS_FOR_JOB_REQUEST_FORM = {
  READY_TO_INTERVIEW: {
    key: 'ready-to-interview',
    label: 'Ready to Interview',
    icon: ReadyToInterview,
  },
  OPEN_TO_OFFERS: {
    key: 'open-to-offers',
    label: 'Open to Offers',
    icon: OpenToOffers,
  },
  UNAVILABILE_FOR_JOBS: {
    key: 'not-looking-for-job',
    label: 'Unavailable for jobs',
    icon: UnAvailableForJobs,
  },
};

export const getAvailabilityAnswerOptions = (isJobInterestForm = false) => {
  const availabilityAnswers = isJobInterestForm
    ? AVAILABILITY_ANSWERS_FOR_JOB_REQUEST_FORM
    : AVAILABILITY_ANSWERS;
  return Object.keys(availabilityAnswers).map((key) => ({
    label: availabilityAnswers[key].label,
    key: availabilityAnswers[key].key,
    icon: availabilityAnswers[key].icon,
    color: availabilityAnswers[key].color
  }));
};

export const WEEKS_TO_START_LABEL = [
  { value: 0, label: 'Now' },
  { value: 1, label: 'in 1 week' },
  { value: 2, label: 'in 2 weeks' },
  { value: 3, label: 'in 3 weeks' },
  { value: 4, label: 'in 1 month' },
  { value: 5, label: 'in more than 1 month' },
];
